module.exports = __webpack_public_path__ + "img/repair-2.e8be8e98.jpg";